
export type SongCookie = {
    date: string; // YYYY-MM-DD
    spotifyId: string;
}

export const getSavedSongs = (): SongCookie[] | null => {
    const songCookies = JSON.parse(window.localStorage.getItem('mp-song-a-day-songs') || 'null');
    return songCookies || null;
}

export const saveNewSong = (newSong: SongCookie) => {
    const songCookies = JSON.parse(window.localStorage.getItem('mp-song-a-day-songs') || 'null');
    let newCookies = songCookies ? [...songCookies, newSong] : [newSong];
    window.localStorage.setItem('mp-song-a-day-songs', JSON.stringify(newCookies));
}

export const removeSong = (songId: string, date: string) => {
    const songCookies: SongCookie[] = JSON.parse(window.localStorage.getItem('mp-song-a-day-songs') || 'null');
    if (songCookies) {
        const newCookies = songCookies.filter(s => s.spotifyId !== songId || s.date !== date );
        console.log(`removed ${songCookies.length - newCookies.length} songs`);
        window.localStorage.setItem('mp-song-a-day-songs', JSON.stringify(newCookies));
    }
}

